module.exports = __webpack_public_path__ + "static/media/gse.e4875851.svg";